// extracted by mini-css-extract-plugin
export default {"mobileBreakPoint":"780px","experienceList":"experienceList_experienceList__shaV2"};